import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IDevicePicture, IDevicePictureUpdate } from '@app/api/interfaces/device-picture.interface';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoisePicturesActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  UpdatePicture = 'UpdatePicture',
  UpdatePictureSuccess = 'UpdatePictureSuccess',
  UpdatePictureError = 'UpdatePictureError',
}

export interface FpLoggerNoisePicturesActionGetData {
  type: FpLoggerNoisePicturesActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoisePicturesActionGetDataSuccesses {
  type: FpLoggerNoisePicturesActionType.GetDataSuccesses;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: IDevicePicture[] | null;
}

export interface FpLoggerNoisePicturesActionGetDataError {
  type: FpLoggerNoisePicturesActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoisePicturesActionUpdatePicture {
  type: FpLoggerNoisePicturesActionType.UpdatePicture;
  pictureId: string;
  update: IDevicePictureUpdate;
}

export interface FpLoggerNoisePicturesActionUpdatePictureSuccess {
  type: FpLoggerNoisePicturesActionType.UpdatePictureSuccess;
  picture: IDevicePicture;
}

export interface FpLoggerNoisePicturesActionUpdatePictureError {
  type: FpLoggerNoisePicturesActionType.UpdatePictureError;
  error: IApiBaseErrorResponse;
}

export type FpLoggerNoisePicturesActions =
  | FpLoggerNoisePicturesActionGetData
  | FpLoggerNoisePicturesActionGetDataSuccesses
  | FpLoggerNoisePicturesActionGetDataError
  | FpLoggerNoisePicturesActionUpdatePicture
  | FpLoggerNoisePicturesActionUpdatePictureSuccess
  | FpLoggerNoisePicturesActionUpdatePictureError;
